import { useAscContext } from '@neo.tax/asc/context';
import { AnalysisType, RedirectState, useUnfinishedSyncEventInPeriodByAnalysisType } from '@neo.tax/shared';

export const useAscWagesRedirect = (): RedirectState => {
  const { fiscalYearId, periodName } = useAscContext();
  const { loading: loadingUnfinishedSyncEventsPeriod } = useUnfinishedSyncEventInPeriodByAnalysisType({
    fiscalYearId,
    periodName,
    analysisType: AnalysisType.Asc,
  });

  return {
    isLoading: loadingUnfinishedSyncEventsPeriod,
  };
};
